"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

/**
 * Electron deep-links NO-auth — 2026-09-07.
 *
 * El main-process (electron/main.js handleDeepLink) carga los callbacks
 * `/auth/*` directo por loadURL (necesitan la partición persist:vortixy con
 * sus cookies) y reenvía el resto (futuro: /chat, /pricing…) al renderer por
 * IPC "deep-link". Este suscriptor los navega interno con router.push — sin
 * recargar el webview, sin perder estado.
 *
 * NativeAuthDeepLinkHandler mantiene auth en exclusiva (lo ignora todo lo que
 * no sea vortixy://auth/callback); este handler ignora /auth/* en exclusiva.
 * No-op en web (sin window.electronAPI).
 */
export function NativeDeepLinkHandler() {
  const router = useRouter();

  useEffect(() => {
    if (typeof window === "undefined") return;
    const api = (
      window as unknown as {
        electronAPI?: { onDeepLink?: (cb: (route: string) => void) => void };
      }
    ).electronAPI;
    if (!api?.onDeepLink) return;

    api.onDeepLink((route: string) => {
      if (typeof route !== "string") return;
      // Solo rutas internas seguras; auth lo maneja NativeAuthDeepLinkHandler.
      if (!route.startsWith("/") || route.startsWith("//")) return;
      if (route.length > 2048 || route.includes("\\")) return;
      if (route.startsWith("/auth/")) return;
      router.push(route);
    });
  }, [router]);

  return null;
}
